<template>
  <div v-if="isLoggedIn">
    <div class="row">
      <div class="col-md-12 alert-message">
        <Message v-if="data.success !== ''" severity="success" closable>
          {{ data.success }}
        </Message>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ChangePassword v-if="data.showChangePassword" @close="toggleChangePassword"></ChangePassword>
        <ChangeProfile
          :attribute_fields="data.attribute_fields"
          v-if="data.showEditProfile"
          @close="toggleEditProfile"
        ></ChangeProfile>
        <ChangeAvatar v-if="data.showEditAvatar" @close="toggleEditAvatar"></ChangeAvatar>
        <RequestDelete v-if="data.showDeleteForm" @close="toggleDeleteForm"></RequestDelete>
      </div>
    </div>
    <wdw-dynbox title="Mein Profil" v-if="showProfile">
      <template #dynamicTitle>
        <div class="dropdown d-inline-block float-end">
          <button
            id="actionsMenuToggle"
            type="button"
            class="btn btn-primary dropdown-toggle btn-profile-actions"
            role="button"
            aria-haspopup="true"
            aria-controls="actions_menu"
            @click="toggleActionsMenu"
          >
            Aktionen
          </button>

          <Menu ref="actionsMenu" id="actions_menu" class="wdw-widgets" :model="actionMenuItems" :popup="true">
            <template #item="{ item }">
              <a
                class="dropdown-item"
                :class="item.action"
                tabindex="0"
                role="link"
                @click="item.click"
                @keydown.enter="item.click"
              >
                {{ item.label }}
              </a>
            </template>
          </Menu>
          <!-- 
          <SplitButton 
            type="button"
            class="btn-profile-actions wdw-widgets"
            label="Aktionen" 
            @click="toggleDropdown"
            :model="actionMenuItems"
            pt:menu:class="wdw-widgets"
            pt:menu:atts:class="wdw-widgets"
          >
          </SplitButton> -->
        </div>
      </template>
      <template #default>
        <div class="row">
          <div class="col-md-4 text-center">
            <img class="avatar" :src="user.avatar_uri" />
          </div>
          <div class="col-md-8">
            <p>
              <strong>Öffentlicher Benutzername:</strong>
              <br />
              {{ user.public_name }}
            </p>
            <p>
              <strong>E-Mail Adresse:</strong>
              <br />
              {{ user.email }}
            </p>
            <div v-if="data.canToggleReceiveProjectEmails">
              <strong>Benachrichtigungen zu Beteiligungsprojekten per E-Mail erhalten</strong>
              <br />
              <div class="form-check form-switch">
                <input
                  @click="toggleReceiveProjectEmails()"
                  class="form-check-input"
                  type="checkbox"
                  :checked="data.userReceiveProjectEmails"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </wdw-dynbox>
    <wdw-dynbox v-if="data.showNewsLetterSubscription" class="newsletter" title="Newsletterabonnements verwalten">
      <NewsletterSubscriptions></NewsletterSubscriptions>
      <button type="button" class="btn btn-default btn-form-cancel" name="cancel" @click="toggleNewsLetterSubscription">
        Zurück
      </button>
    </wdw-dynbox>
    <OwnerThoughtList :config="{ enableEdit: false }" :user="user" />
  </div>
  <div v-else>Sie sind nicht eingeloggt, Profil nicht verfügbar.</div>
</template>

<script>
import { userStore } from '@/store/user-store';
import { onMounted, reactive, computed, ref } from 'vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { RepositoryFactory } from '@/api/repositoryFactory';

import OwnerThoughtList from '@/components/discuss/thought/OwnerThoughtList.vue';
import NewsletterSubscriptions from '@/components/user/NewsletterSubscriptions.vue';
import ChangePassword from '@/components/user/profile/ChangePassword.vue';
import ChangeAvatar from '@/components/user/profile/ChangeAvatar.vue';
import ChangeProfile from '@/components/user/profile/ChangeProfile.vue';
import RequestDelete from '@/components/user/profile/RequestDelete.vue';
import useConverter from '@/composables/general/useConverter';

import SplitButton from 'primevue/splitbutton';
import Menu from 'primevue/menu';
import Message from 'primevue/message';

const UserRepository = RepositoryFactory.get('user');
const DomainRepository = RepositoryFactory.get('domain');

/*
Still in development
upgrade to a "user" component
Should Contain:
    -[x] User Profile
    -[x] Editing Name
    -[x] Changing Avatar
    -[x] Changing Passwort
    -[x] Delete Request
    -[ ] Newsletters (with option su subscribe/unsubscribe, see wdw-server profile)
*/

export default {
  name: 'profile',

  props: {
    domainid: {
      type: Number,
      required: true,
    },
  },

  setup(props) {
    const data = reactive({
      // Attributes for change-profile
      attribute_fields: [],
      //show modules
      showChangePassword: false,
      showEditProfile: false,
      showEditAvatar: false,
      showDeleteForm: false,
      showNewsLetterSubscription: false,
      // User can enable/disable project emails
      canToggleReceiveProjectEmails: false,
      userReceiveProjectEmails: 0,
      // Success message
      success: '',
    });
    const actionsMenu = ref(null);
    const { toBool } = useConverter();

    //+---------------------+
    //|   computed          |
    //+---------------------+

    const user = computed(() => {
      return userStore.getState().user;
    });

    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const showProfile = computed(() => {
      return (
        !data.showChangePassword &&
        !data.showEditProfile &&
        !data.showEditAvatar &&
        !data.showDeleteForm &&
        !data.showDeleteForm &&
        !data.showNewsLetterSubscription
      );
    });

    //+--------------------+
    //|    Methods         |
    //+--------------------+

    const toggleChangePassword = message => {
      data.showChangePassword = !data.showChangePassword;
      data.showEditAvatar = false;
      data.showEditProfile = false;
      data.showDeleteForm = false;
      data.showNewsLetterSubscription = false;

      if (message !== '' && message !== undefined && typeof message == 'string') {
        data.success = message;
      }
    };
    const toggleEditProfile = message => {
      data.showEditProfile = !data.showEditProfile;
      data.showEditAvatar = false;
      data.showChangePassword = false;
      data.showDeleteForm = false;
      data.showNewsLetterSubscription = false;
    };
    const toggleEditAvatar = () => {
      data.showEditAvatar = !data.showEditAvatar;
      data.showEditProfile = false;
      data.showChangePassword = false;
      data.showDeleteForm = false;
      data.showNewsLetterSubscription = false;
    };
    const toggleDeleteForm = () => {
      data.showDeleteForm = !data.showDeleteForm;
      data.showEditAvatar = false;
      data.showEditProfile = false;
      data.showChangePassword = false;
      data.showNewsLetterSubscription = false;
    };
    const toggleNewsLetterSubscription = () => {
      data.showNewsLetterSubscription = !data.showNewsLetterSubscription;
      data.showDeleteForm = false;
      data.showEditAvatar = false;
      data.showEditProfile = false;
      data.showChangePassword = false;
    };
    const toggleActionsMenu = e => {
      actionsMenu.value.toggle(e);
    };

    // Toggle user.receive_project_emails
    const toggleReceiveProjectEmails = () => {
      if (toBool(user.value.receive_project_emails)) {
        UserRepository.putToggleReceiveProjectEmails(user.value.id, 0).then(resp => {
          data.userReceiveProjectEmails = resp.data.data.receive_project_emails;
        });
      } else {
        UserRepository.putToggleReceiveProjectEmails(user.value.id, 1).then(resp => {
          data.userReceiveProjectEmails = resp.data.data.receive_project_emails;
        });
      }
    };

    const actionMenuItems = [
      {
        label: 'Profilbild ändern',
        action: 'profile-action-avater profile-action-avatar',
        click: toggleEditAvatar,
      },
      {
        label: 'Passwort ändern',
        action: 'profile-action-pw',
        click: toggleChangePassword,
      },
      {
        label: 'Profil bearbeiten',
        action: 'profile-action-edit',
        click: toggleEditProfile,
      },
      {
        label: 'Löschen beantragen',
        action: 'profile-action-delete',
        click: toggleDeleteForm,
      },
      {
        label: 'Newsletterabonnements verwalten',
        action: 'profile-action-newsletter',
        click: toggleNewsLetterSubscription,
      },
    ];

    onMounted(() => {
      // Retrieve registration fields from API
      DomainRepository.getRegistrationConfig()
        .then(function (response) {
          const resp_fields = response.data.data;

          // T18085: If the returned config has `receive_project_emails`, user should be able to switch on/off
          data.canToggleReceiveProjectEmails =
            resp_fields.newsletter_fields.findIndex(field => field.code == 'receive_project_emails') >= 0;

          data.userReceiveProjectEmails = user.value.receive_project_emails;

          // TODO
          // fix profile attributes for editing
          // data.attribute_fields = resp_fields.attribute_fields.filter( f => { if(f.public == 1){return true}});
          data.attribute_fields = [];
        })
        .catch(err => {
          console.log(err);
        });
    });

    return {
      // ---VARIABLE---
      // Computed methods
      user,
      isLoggedIn,
      showProfile,
      actionMenuItems,
      // Listeners
      toggleChangePassword,
      toggleEditProfile,
      toggleEditAvatar,
      toggleDeleteForm,
      toggleNewsLetterSubscription,
      toggleReceiveProjectEmails,
      toggleActionsMenu,
      // Other
      actionsMenu,
      data,
    };
  },

  components: {
    WdwDynbox,
    OwnerThoughtList,
    NewsletterSubscriptions,
    // SplitButton,
    Menu,
    Message,
    ChangePassword,
    ChangeAvatar,
    ChangeProfile,
    RequestDelete,
  },
};
</script>

<style scoped>
.avatar {
  padding: 4px;
  background-color: var(--wdw-background-color);
  border: 1px solid #ddd;
  width: 100%;
  max-width: 256px;
  height: auto;
}
.alert-message {
  display: contents;
}
</style>
